import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class ExceptionsComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentWidthRatio = component.width / 1200.0 * dimentionsRatio;
        const componentHeightRatio = component.height / 500.0 * dimentionsRatio;

        const height = 100 * componentHeightRatio;
        const smallWidth = 100 * componentWidthRatio;
        const bigWidth = 950 * componentWidthRatio;

        const firstElementPosX = component.drawPositionX + 50 * componentWidthRatio;
        const secondElementPosX = component.drawPositionX + 200 * componentWidthRatio;
        const firstElementPosY = component.drawPositionY + 50 * componentHeightRatio;
        const secondElementPosY = component.drawPositionY + 200 * componentHeightRatio;
        const thirdElementPosY = component.drawPositionY + 350 * componentHeightRatio;

        const componentSecundaryColor = "#DCEEF6";
        const componentWidth = component.width * dimentionsRatio;
        const componentHeight = component.height * dimentionsRatio;
        
        let fontSize = height;
        if(6 * fontSize > componentWidth) {
            fontSize = componentWidth / 6.0;
        }

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={componentWidth}
                    height={componentHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Text text={component.text}
                        fontSize={fontSize}
                        x={firstElementPosX}
                        y={firstElementPosY} />
                </Group>

                <Group>
                    <Rect x={firstElementPosX}
                        y={secondElementPosY}
                        width={smallWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Rect x={secondElementPosX}
                        y={secondElementPosY}
                        width={bigWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>

                <Group>
                    <Rect x={firstElementPosX}
                        y={thirdElementPosY}
                        width={smallWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Rect x={secondElementPosX}
                        y={thirdElementPosY}
                        width={bigWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/ExceptionsComponentCanvas.js